export const dictionaryContext = {
  dictionary: '/dictionary-service/api/external/dictionary/value',
  dictionaryItem: '/dictionary-service/api/external/dictionary/value/{id}',
  regions: '/dictionary-service/api/external/dictionary/suggestions',
  shippingTerms: '/dictionary-service/api/external/dictionary/shippingTerms',
  availableCurrencies: '/dictionary-service/api/external/dictionary/availableCurrencies',
  geoCodeChange: '/user-service/api/external/forwardGeocode',
};
